module.exports = __webpack_public_path__ + "img/schemeList09.0123a2d9.png";